import {
    BoldSubtitleText,
    SubtitleText,
} from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/styledComponents";
import { ChangeValue } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import type { FC } from "react";
import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";
import styled from "styled-components";
import { minVisitsAbbrFilter, percentageSignFilter } from "app/filters/ngFilters";
import type { IChart } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import { translate } from "app/filters/i18nFilter";

const InfoIconContainer = styled.div`
    margin-top: -1px;
`;

const ItemsContainer = styled(FlexRow)`
    gap: 4px;
`;

const Change = styled(ChangeValue)`
    margin-top: -1px;
`;

interface ISubtitle extends IChart {}

const Container = styled.div`
    display: flex;
    gap: 8px;
    padding: 12px 24px 0px 24px;
`;

export const Subtitle: FC<ISubtitle> = (props) => {
    const { chartState } = props;
    const rawData = chartState.rawData;
    if (!rawData) {return null;}
    const { Totals: totals } = rawData;
    const { AvgVisits: averageVisits, VisitsChange: visitsChange } = totals;
    const monthlyVisits = averageVisits;
    return (
        <Container>
            <ItemsContainer>
                <SubtitleText>{translate("market.segmentation.size.growth.bar.chart.subtitle")}</SubtitleText>
                <InfoTooltip
                    infoText={translate("market.segmentation.size.growth.bar.chart.subtitle.tooltip")}
                    infoIconContainer={InfoIconContainer}
                />
            </ItemsContainer>
            <ItemsContainer>
                <BoldSubtitleText>{minVisitsAbbrFilter()(monthlyVisits)}</BoldSubtitleText>
                <SubtitleText>Monthly Visits, </SubtitleText>
            </ItemsContainer>
            <ItemsContainer>
                <Change
                    value={percentageSignFilter()(visitsChange, 2)}
                    isDecrease={visitsChange < 0}
                />
                <SubtitleText>Period Change</SubtitleText>
            </ItemsContainer>
        </Container>
    );
};
